import type { ButtonHTMLAttributes, ReactNode } from 'react';
import Apertavel from '@/components/movimento/Apertavel';

interface PrimaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icone?: string;
  carregando?: boolean;
  /** Largura total no celular. */
  cheio?: boolean;
  children: ReactNode;
}

// Botão principal do app: 56 px, azul, sombra azul suave.
export default function PrimaryButton({
  icone,
  carregando = false,
  cheio = false,
  className = '',
  disabled,
  children,
  ...rest
}: PrimaryButtonProps) {
  return (
    <Apertavel
      disabled={disabled || carregando}
      className={`inline-flex h-14 items-center justify-center gap-2 whitespace-nowrap rounded-[18px] bg-primary-500 px-6 text-[15px] font-bold text-white shadow-pbtn transition-colors hover:bg-primary-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 disabled:cursor-not-allowed disabled:opacity-60 ${
        cheio ? 'w-full' : ''
      } ${className}`}
      {...rest}
    >
      {carregando ? (
        <span className="flex h-5 w-5 items-center justify-center">
          <i className="ri-loader-4-line animate-spin" aria-hidden />
        </span>
      ) : icone ? (
        <span className="flex h-5 w-5 items-center justify-center">
          <i className={icone} aria-hidden />
        </span>
      ) : null}
      {children}
    </Apertavel>
  );
}